import type { AccountTransferRequest } from '../types/crm';

export interface AccountTransferOptions {
  message?: string;
  includeSubCompanies?: boolean;
  includeProjects?: boolean;
  includeTasks?: boolean;
}

type ScopeFlags = {
  include_sub_companies?: boolean;
  include_projects?: boolean;
  include_tasks?: boolean;
};

/** Account transfer only changes salesperson code (+ optional sub-companies). */
export function formatTransferScope(
  request: Pick<AccountTransferRequest, 'include_sub_companies' | 'include_projects' | 'include_tasks'> | ScopeFlags,
): string {
  const parts: string[] = ['account salesperson code'];
  if (request.include_sub_companies) parts.push('sub-companies');
  return parts.join(', ');
}
